export default {
  home: '首页',
  template: '组件',
  table: '表格',
  swiper: '轮播',
  menus: '多级菜单',
  menu1: '菜单1',
  'menu1-1': '菜单1-1',
  'menu1-2': '菜单1-2',
  'menu1-2-1': '菜单1-2-1',
  'menu1-2-2': '菜单1-2-2',
  'menu1-3': '菜单1-3',
  menu2: '菜单2',
  permission: '权限管理',
  permissionPage: '页面权限',
  permissionButton: '按钮权限',
  externalLink: '外链',
  menuManagement: '菜单管理',
  systemManagement: '系统管理',
  permissionRole: '角色权限',
  menusManagement: '菜单管理',
  templateManagement: '模板管理',
  functional: '功能',
  download: '下载',
  print: '打印',
  debounceAndThrottle: '防抖节流',
};
